import React from 'react';
import * as _ from 'lodash';
import { UNAPPROVED_TYPE } from '../utilities/constants';
import EventManager, { EventType } from '../utilities/EventManager';
import { isPrimaryCompanyRoleId } from '../utilities/roleUtility';
import { messageUtility } from '../utilities/messageUtility';
import SessionStorageService from '../services/utilities/SessionStorageService';

export default class UnapprovedWorksPageHeader extends React.Component {
  constructor(props) {
    super(props);
    const unapprovedWorksCount = SessionStorageService.getUnapprovedWorksCount();
    this.isPrimaryCompanyRoleId = isPrimaryCompanyRoleId();

    this.state = {
      totalCount: _.sum(_.values(unapprovedWorksCount)) || 0,
      listMenu: this.getMenuList(unapprovedWorksCount || {}),
    };
  }

  getMenuList = unapprovedWorksCount => {
    if (this.isPrimaryCompanyRoleId) {
      return [
        {
          name: '予定\n未承認',
          page: 'WorkScheduleUnapproved',
          active: !!unapprovedWorksCount.unapproved_schedule_works_count,
          unapproved_type: UNAPPROVED_TYPE.UNAPPROVED.value,
          icon_warning: (
            <i className='icon-warning_round UnapprovedWorksPageHeader__list-menu__icon--warning' />
          ),
          icon: (
            <span className='UnapprovedWorksPageHeader__list-menu__icon--text'>
              元
            </span>
          ),
        },
        {
          name: '実績\n未承認',
          page: 'WorkResultUnapproved',
          active: !!unapprovedWorksCount.unapproved_works_count,
          unapproved_type: UNAPPROVED_TYPE.UNAPPROVED.value,
        },
        {
          name: '予定\n未受領',
          page: 'WorkScheduleUnapproved',
          active: !!unapprovedWorksCount.partner_unapproved_schedule_works_count,
          icon: (
            <span className='UnapprovedWorksPageHeader__list-menu__icon--text'>
              協
            </span>
          ),
          unapproved_type: UNAPPROVED_TYPE.UNCONFIRMED.value,
        },
        {
          name: '実績\n未確定',
          page: 'WorkResultUnapproved',
          active: !!unapprovedWorksCount.partner_unapproved_works_count,
          unapproved_type: UNAPPROVED_TYPE.UNCONFIRMED.value,
        },
      ];
    }

    return [
      {
        name: '予定\n未受領',
        page: 'WorkScheduleUnapproved',
        active: !!unapprovedWorksCount.partner_unapproved_schedule_works_count,
        unapproved_type: UNAPPROVED_TYPE.UNCONFIRMED.value,
      },
      {
        name: '実績\n未確定',
        page: 'WorkResultUnapproved',
        active: !!unapprovedWorksCount.partner_unapproved_works_count,
        unapproved_type: UNAPPROVED_TYPE.UNCONFIRMED.value,
      },
    ];
  };

  componentDidMount() {
    EventManager.addEventListener(
      EventType.UPDATE_UNAPPROVED_WORKS_COUNT,
      unapprovedWorksCount => {
        this.setState({
          listMenu: this.getMenuList(unapprovedWorksCount),
          totalCount: _.sum(_.values(unapprovedWorksCount)),
        });
      }
    );
  }

  componentWillUnmount() {
    EventManager.deleteEvent(EventType.UPDATE_UNAPPROVED_WORKS_COUNT);
  }

  loadPageFuncNavi = menu => {
    const { active, page, unapproved_type } = menu;
    if (!active) {
      return;
    }

    SessionStorageService.setDefaultUnapprovedFilterValue(unapproved_type);
    EventManager.trigger(EventType.REFRESH_UNAPPROVED_WORKS_COUNT);
    EventManager.trigger(EventType.RESET_FILTER_UNAPPROVED_WORK_PAGE);
    EventManager.trigger(EventType.LOAD_PAGE_FUNC_NAVI, page);
  };

  render() {
    const { totalCount, listMenu } = this.state;

    if (!totalCount) {
      return null;
    }

    return (
      <div className='UnapprovedWorksPageHeader'>
        <div className='UnapprovedWorksPageHeader__list-menu'>
          <div className='UnapprovedWorksPageHeader__info'>
            <span>{messageUtility.getMessage('I-001-541')}</span>
            <div className='UnapprovedWorksPageHeader__info--sub-text'>
              {messageUtility.getMessage('I-001-542')}
            </div>
          </div>
          {_.map(listMenu, (menu, index) => (
            <div key={index} className='UnapprovedWorksPageHeader__menu-item'>
              {menu.icon_warning}
              {menu.icon}
              <span className='UnapprovedWorksPageHeader__menu-name'>
                {menu.name}
              </span>
              <span
                className={`UnapprovedWorksPageHeader__menu-item__btn UnapprovedWorksPageHeader__menu-item__btn-${
                  menu.active ? 'active' : 'inactive'
                }`}
                onClick={() => this.loadPageFuncNavi(menu)}
              >
                {menu.active ? 'あり' : 'なし'}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UnapprovedWorksPageHeader.jsx